import { isCapacitorPlatform } from "@utils/specific/capacitor/helpers";

export function getReleaseVersion() {
	if (isCapacitorPlatform && isCapacitorPlatform()) {
		return WEBPACK_CAPACITOR_APP_VERSION;
	}

	return WEBPACK_APP_VERSION;
}
